import React, {
    useState,
    useEffect
} from 'react';
import styled, {css} from "styled-components";

const Wrapper = styled.div.attrs(props => ({
    height: props.height || 'auto',
    marginBottom: props.marginBottom || 0
}))`
    height: ${props => props.height};
    margin-bottom: ${props => props.marginBottom};

    ${props => props.theme.mediaQueries.medium}{
        margin-top: ${props => props.marginTopMediaQueriesMedium};
        margin-bottom: ${props => props.marginBottomMediaQueriesMedium};
    }
`

const Img = styled.img`
    width: 100%;
    object-fit: cover;

    ${props => props.theme.mediaQueries.medium}{
        height: 100%;
        //object-fit: fill;
        max-width: ${props => props.maxWidth || '100%'};// 820px;
        max-height: ${props => props.maxHeight};
    }
`

const ImageContainer = ({
    imgSrc,
    ...props
}) => {


    return (
        <Wrapper {...props}>
            <Img 
                src={imgSrc}
                {...props}
            />
        </Wrapper>

    )
}

export default ImageContainer;